import EventEmitter from 'methods/eventEmitter';
import {delay, isMobile, declension, createElement, getDateTitleFormatted, error, getRandomIntNumberInRange} from 'methods/utils';
import Layout from 'components/layout';
import Typer from 'components/typer';

/**
 * Поиск по географии
 */
function GeoPicker($container, options = {}) {
    // наследуемся
    EventEmitter.call(this);

    this._$container = typeof $container == 'undefined' ? document.body : $container;
    this._$form      = this._$container.classList.contains('js-filterForm') ? this._$container : this._$container.querySelector('.js-filterForm');
    this._search     = options._search ? options._search : null;

    // рендер модалки поиска
    this._renderModal = function() {
        let hasAppend = false;
        const $div    = document.createElement('div');

        this._$form.appendChild($div);

        $div.outerHTML = `${isMobile() ? '<div class="search-v2 is-hidden">' : ''}<div class="search-modal js-searchModal">
            <div class="search-modal__header">
                <div class="search-modal__header-close js-searchModalClose">
                    <svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M24 8L2 8M2 8L8.5 14.5M2 8L8.5 1.5" stroke="currentColor" stroke-width="2"/>
                    </svg>
                </div>
                <div class="search-modal__header-container">
                    <div class="search-modal__header-title">Курорт или отель</div>
                    <div class="search-modal__header-input">
                        <div class="search-preview is-hidden js-searchPreview">
                            <span class="first-part js-firstPart"></span>
                            <span class="second-part js-secondPart"></span>
                        </div>
                        <input type="text" name="query" placeholder="Где хотите отдохнуть?" autocomplete="off"${options.formId ? ' form="' + options.formId + '"' : ''}>
                        <div class="search-modal__header-cross js-searchModalCross">
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20.9497 11.0503L11.0502 20.9498" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M11.0503 11.0503L20.9498 20.9498" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
            <div class="search-modal__blocks js-searchModalBlocks"></div>
        </div>${isMobile() ? '</div>' : ''}`;
    }
    this._renderModal();

    this._$searchPreview    = this._$form.querySelectorAll('.js-searchPreview');
    this._$searhCross       = this._$form.querySelector('.js-searhCross');
    this._$searchWrapper    = this._$form.querySelector('.js-searchWrapper');
    this._$searchInput      = this._$form.querySelector('.js-searchInput');
    this._$searchButton     = this._$form.querySelector('.js-searchButton');
    this._$searchErrorItem  = this._$form.querySelector('.js-searchErrorItem');
    this._$searchErrorTitle = this._$form.querySelector('.js-searchErrorTitle');
    this._inputValue        = this._$searchInput.value;

    this._$searchModal        = this._$form.querySelector('.js-searchModal');
    this._$searchModalClose   = this._$searchModal.querySelector('.js-searchModalClose');
    this._$searchModalInput   = this._$searchModal.querySelector('input[name="query"]');
    this._$searchModalCross   = this._$searchModal.querySelector('.js-searchModalCross');
    this._$searchModalBlocks  = this._$searchModal.querySelector('.js-searchModalBlocks');
    this._$searchItems        = this._$form.getElementsByClassName('js-searchItem');

    if (isMobile()) {
        this._$searchModalWrapper = this._$searchModal.parentNode;
    } else {
        this._$searchModalWrapper = this._$searchModal;
    }

    // скрываем при иниц чтобы корректно работал this._modalOpened
    this._$searchModalWrapper.classList.add('is-hidden');

    this._storage = {};

    this.setSearchTitle = function(title) {
        if (title == 'Курорт') {
            this._$searchInput.value = '';
            this._inputValue         = '';
        } else {
            this._$searchInput.value = title.trim();
            this._inputValue         = title.trim();
        }

        this._$searhCross.classList.toggle('is-hidden', !this._$searchInput.value);
    }

    this.setSearchHref = function(href) {
        this._$searchInput.dataset.href = href;
    }

    this.getSearchTitle = function() {
        return this._inputValue;
    }

    this._searchSuggestion = function(query, expectedString) {
        const regex = /\s/g;

        this._$searchPreview.forEach($container => {
            const $firstPart  = $container.querySelector('.js-firstPart');
            const $secondPart = $container.querySelector('.js-secondPart');
            const $input      = $container.parentElement.querySelector('input[type="text"]');

            // начало строк должно совпадать
            if (query.length > 0 && expectedString.toUpperCase().indexOf(query.toUpperCase()) == 0) {
                // показываем превью
                $container.classList.remove('is-hidden');

                $firstPart.innerHTML  = expectedString.slice(0, query.length).replace(regex, '&nbsp;');
                $secondPart.innerHTML = expectedString.substring(query.length).replace(regex, '&nbsp;');

                $input.value = expectedString.substring(0, query.length);
            }
        });
    }

    this._searchInputPlaceholderChange = function() {
        if (!this._$searchInput) {
            return;
        }

        const typer = new Typer(this._$searchInput, {
            place: 'placeholder',
            texts: [
                'Едем в Сочи',
                'Едем в Казань',
                'Едем на Эльбрус',
            ],
            speed: 50,
            delay: 2000,
            loop: true,
        });

        setTimeout(() => typer.start(getRandomIntNumberInRange(0, 2)), 2000);
    }

    this._searchSuggestionHide = function() {
        this._$searchPreview.forEach($container => $container.classList.add('is-hidden'));
    }

    this._modalOpened = function() {
        return !this._$searchModalWrapper.classList.contains('is-hidden');
    }

    this._modalOpen = function() {
        if (this._modalOpened()) {
            return
        }

        this._$searchModalWrapper.classList.remove('is-hidden');
        this._$searchModalInput.focus();

        if (isMobile()) {
            const $documentHeader = document.querySelector('.js-header');
            if ($documentHeader) {
                $documentHeader.classList.add('is-hidden');
            }

            Layout.scroll.disable('geopicker');
        }
    }

    this._modalClose = function() {
        if (!this._modalOpened()) {
            return;
        }

        // отмена запроса
        if (this._abortController) {
            this._abortController.abort();
        }

        this._$searchModalWrapper.classList.add('is-hidden');

        if (isMobile()) {
            const $documentHeader = document.querySelector('.js-header');
            if ($documentHeader) {
                $documentHeader.classList.remove('is-hidden');
            }

            Layout.scroll.enable('geopicker');
        }

        this.emit('hide');
    }

    this._moveToElement = function(e, type = 'next') {
        let isActiveIndex = -1;
        let lastIndex     = this._$searchItems.length - 1;

        e.preventDefault();
        e.stopPropagation();

        [...this._$searchItems].forEach(($item, i) => {
            if ($item.classList.contains('is-active')) {
                isActiveIndex = i;
                $item.classList.remove('is-active');
            }
        });

        if (type == 'next') {
            if (isActiveIndex == lastIndex) {
                isActiveIndex = 0;
            } else {
                isActiveIndex++;
            }
        }

        if (type == 'prev') {
            if (isActiveIndex == 0) {
                isActiveIndex = lastIndex;
            } else {
                isActiveIndex--;
            }
        }

        let item = [...this._$searchItems][isActiveIndex];
            item.classList.add('is-active');
        this._$searchInput.dataset.href = item.dataset.href;
        this._$searchInput.dataset.city = item.dataset.city;
    }

    this._makeRequest = function(silent = false) {
        let queryInitial = this._$searchInput.value;
        let query        = queryInitial.trim();

        // дропаем пред запрос
        if (this._abortController) {
            this._abortController.abort();
        }

        // убираем прелоадер
        this._$searchButton.classList.remove('is-loading');

        // кеширование
        if (typeof this._storage[query] !== 'undefined') {
            return this._render(queryInitial, this._storage[query]);
        }

        let data = new FormData();
            data.append('search_input', query);
        this._abortController = new AbortController();

        // прелоадер
        this._$searchButton.classList.add('is-loading');

        delay(function() {
            fetch('/main/search_result_v2/', {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: data,
                signal: this._abortController.signal,
            })
            .then(response => response.json())
            .then(r => {
                if (r.status == 'ok') {
                    this._storage[query] = r.blocks;

                    if (silent) {
                        this.setSearchHref(r.blocks[0]['list'][0]['url']);
                    } else {
                        this._render(query, r.blocks);
                    }
                } else {
                    // показываем ошибку
                    if (this._$searchInput && !this._$searchInput.dataset.href) {
                        this._$searchErrorItem.classList.add('is-active');
                        this._$searchErrorTitle.textContent = 'Ничего не найдено';
                        this._$form.classList.remove('is-loading');
                    }

                    // закрываем модалку
                    this._renderEmpty();
                }
            }).catch(e => {
                // пользователь мог отменить запрос закрыв модалку
                error(e);
            }).finally(() => {
                this._$searchButton.classList.remove('is-loading');
            });
        }.bind(this), 500);
    }

    this._render = function(query, blocks) {
        // снимаем ошибки
        if (this._$searchErrorItem) {
            this._$searchErrorItem.classList.remove('is-active');
        }

        // выбираем первый
        if (blocks && Array.isArray(blocks) && blocks.length > 0) {
            this._searchSuggestion(query, blocks[0].list[0].title);

            if (this._search && !query) {
                // удаляем старый block_type: 'local'
                blocks.forEach((item, index) => {
                    if (item.block_type == 'local') {
                        blocks.splice(index, 1);
                    }
                });

                // добавляем block_type: 'local'
                let list = this._search._getSearch();
                if (list && list.length > 0) {
                    list = list.map(item => {
                        let subtitle = [];

                        if (item.city && item.city != 'undefined') {
                            let people = item.adults + item.childrens;
                            subtitle.push(`${item.city}`);
                        }

                        if (item.startDate && item.endDate) {
                            let start = getDateTitleFormatted(new Date(item.startDate), 'noWeekday');
                            let end   = getDateTitleFormatted(new Date(item.endDate), 'noWeekday');

                            subtitle.push(`${start} - ${end}`);
                        }

                        if (item.adults) {
                            let people = item.adults + item.childrens;
                            subtitle.push(`${people} ${declension(people, 'гость', 'гостя', 'гостей')}`);
                        }

                        return {
                            isActive: false,
                            subtitle: subtitle.length > 0 ? subtitle.join(' • ') : '',
                            title: item.searchTitle,
                            url: item.searchHref,
                            data: item,
                        }
                    });

                    blocks.unshift({
                        block_title: 'Вы искали',
                        block_type: 'local',
                        list,
                        onclick: 'save',
                    });
                }
            }
        }

        // запоминаем последний рендеринг
        this._$searchModal.dataset.query = query;

        if (blocks && Array.isArray(blocks) && blocks.length > 0) {
            this._$searchModalBlocks.innerHTML = '';

            blocks.forEach((block, i) => {
                if (i == 0) {
                    block.list[0].isActive = true;
                }

                let $block = createElement(`
                    <div class="search-block js-block" data-type="${block.block_type}">
                        <div class="block-header">
                            ${block.block_title}
                        </div>
                    </div>`
                );

                if (block.block_type == 'types') {
                    let $list = createElement(`<div class="block-type-container js-container"></div>`);
                    $block.appendChild($list);

                    block.list.forEach(item => {
                        let $item = createElement(
                            `<div class="block-type-item js-searchItem${item.isActive ? ' is-active' : ''}" data-href="${item.url}"${item.city ? ` data-city="${item.city}"` : ''} data-onclick="${block.onclick}">
                                <div class="block-type-item-title js-title">${item.title}</div>
                                <div class="block-type-item-count">${item.count}</div>
                            </div>`
                        );

                        if (item.data) {
                            $item.data = item.data;
                        }

                        $list.appendChild($item);
                    });
                } else {
                    let $list = createElement(`<div class="block-container js-container"></div>`);
                    $block.appendChild($list);

                    block.list.forEach(item => {
                        let $item = createElement(
                            `<div class="block-item js-searchItem${item.isActive ? ' is-active' : ''}${item.data && (item.data.adults > 0 || item.data.startDate) ? ' full' : ''}" data-href="${item.url}"${item.city ? ` data-city="${item.city}"` : ''} data-onclick="${block.onclick}">
                                <div class="block-item-inner">
                                    <div class="block-item-title js-title"></div>
                                    <div class="block-item-pretitle">${item.subtitle}</div>
                                </div>
                            </div>`
                        );

                        $item.querySelector('.js-title').textContent = item.title;

                        if (item.data) {
                            $item.data = item.data;
                        }

                        $list.appendChild($item);
                    });
                }

                this._$searchModalBlocks.appendChild($block);
            });
        }

        this._modalOpen();

        let arr = [...this._$searchItems];

        if (query && arr[0] && arr[0].dataset.href) {
            this._$searchInput.dataset.href = arr[0].dataset.href;
            this._$searchInput.dataset.city = arr[0].dataset.city;
        }

        arr.forEach($item => $item.addEventListener('click', function(e) {
            const $block = $item.closest('.js-block');
            const $title = $item.querySelector('.js-title');

            this._searchSuggestionHide();

            // снимаем ошибки
            if (this._$searchErrorItem) {
                this._$searchErrorItem.classList.remove('is-active');
            }

            if ($item.data) {
                // закрываем модалку
                this._modalClose()

                return this._search.loadSearch($item.data);
            }

            if ($item.dataset.onclick == 'redirect') {
                if ($block.dataset.type == 'geo') {
                    this._inputValue = $title.textContent;

                    // прокидываем title и url
                    this._$searchInput.value        = $title.textContent;
                    this._$searchInput.dataset.href = $item.dataset.href;
                    this._$searchInput.dataset.city = $item.dataset.city;
                }

                if (location.pathname != $item.dataset.href) {
                    location.href = $item.dataset.href;
                }

                // закрываем модалку
                this._modalClose();

                return;
            }

            if ($item.dataset.onclick == 'save') {
                this._inputValue = $title.textContent;

                // прокидываем title и url
                this._$searchInput.value        = $title.textContent;
                this._$searchInput.dataset.href = $item.dataset.href;
                this._$searchInput.dataset.city = $item.dataset.city;

                this._$searchInput.dispatchEvent(new Event('input', {
                    cancelable: true,
                    bubbles: true,
                }));

                this.emit('city:change');

                this._$form.dispatchEvent(new Event('change'));

                // закрываем модалку
                this._modalClose();

                return;
            }
        }.bind(this)));
    }

    this._renderEmpty = function(query, blocks) {
        // снимаем ошибки
        if (this._$searchErrorItem) {
            this._$searchErrorItem.classList.remove('is-active');
        }

        this._$searchModalBlocks.innerHTML = '<div class="block-header">Ничего не найдено</div>';

        this._modalOpen();
    }

    this.toggleWrapperVisibility = function (visibility)  {
        if (visibility) {
            this._$searchWrapper.style.display = '';
        } else {
            this._$searchWrapper.style.display = 'none';
        }

        return visibility;
    }

    this.init = function() {
        // перевод фокуса на инпут при клике на подсказку
        this._$searchPreview.forEach($container => $container.addEventListener('click', e => {
            $container.parentElement.querySelector('input[type="text"]').focus();
        }));

        // закрытие модалки
        this._$searchModalClose.addEventListener('click', this._modalClose.bind(this));

        // ввод в поле поиска
        this._$searchModalInput.addEventListener('input', function(e) {
            this._$searchInput.value = this._$searchModalInput.value;
            this._$searchModalCross.classList.toggle('is-active', this._$searchModalInput.value.length);

            this._$searchInput.dispatchEvent(new Event('input', {
                cancelable: true,
                bubbles: true,
            }))
        }.bind(this));

        // очистка поиска
        this._$searchModalCross.addEventListener('click', function() {
            this._$searchInput.value = this._$searchModalInput.value = '';
            this._$searchModalInput.focus();
            this._$searchModalCross.classList.toggle('is-active', false);
        }.bind(this));

        this._$searchWrapper.addEventListener('keydown', function(e) {
            if (!this._modalOpened()) {
                return false;
            }

            const keyMap = {
                40: 'next', // кнопка вниз
                38: 'prev', // кнопка вверх
            }

            if (keyMap[e.keyCode]) {
                return this._moveToElement(e, keyMap[e.keyCode]);
            }

            return true;
        }.bind(this));

        this._$searchInput.addEventListener('input', function(e) {
            e.preventDefault();
            e.stopPropagation();

            this._searchSuggestionHide()
            this._$searhCross.classList.toggle('is-hidden', !this._$searchInput.value);

            this._makeRequest();
        }.bind(this));

        this._$searhCross.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();

            this._searchSuggestionHide()
            this._$searhCross.classList.add('is-hidden');

            this._$searchInput.value        = '';
            this._$searchInput.dataset.href = '';
            this._$searchInput.dataset.city = '';

            this._inputValue = '';

            this._makeRequest();
        }.bind(this));

        // кликаем по полю поиска и если модалка не открыта, открываем
        this._$searchWrapper.addEventListener('click', function() {
            this._$searchInput.focus();

            if (!this._modalOpened()) {
                if (isMobile()) {
                    this._modalOpen();
                }

                if (this._$searchInput.value && this._$searchInput.value != 'Курорт') {
                    this._searchSuggestion(this._$searchInput.value, this._$searchInput.value);
                }

                this._makeRequest();
            }
        }.bind(this));

        document.body.addEventListener('click', function (e) {
            // клик вне модалки или поля поиска - закрываем модалку
            if (!this._$searchWrapper.contains(e.target) && !this._$searchModal.contains(e.target)) {
                this._modalClose();
            }

            return false;
        }.bind(this));

        this._searchInputPlaceholderChange();
    }
    this.init();
}

// цепочка прототипов
GeoPicker.prototype = Object.create(EventEmitter.prototype, {
    constructor: {
        value: GeoPicker,
        enumerable: false,
        writable: true,
    }
});

export default GeoPicker;
